import { useMemo } from 'react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import { PropertySchema } from './types.ts'

const types: Array<PropertySchema['type'] | 'date' | 'datetime'> = [
  'string',
  'number',
  'integer',
  'boolean',
  'array',
  'object',
  'date',
  'datetime',
]

interface TypeSelectorProps {
  id: string
  schema: PropertySchema
  onChange: (value: Pick<PropertySchema, 'format' | 'type' | 'items'>) => void
}

export function TypeSelector({ id, schema, onChange }: TypeSelectorProps) {
  const type = useMemo<(typeof types)[number]>(() => {
    if (schema.type === 'string' && schema.format === 'date') return 'date'
    if (schema.type === 'string' && schema.format === 'datetime')
      return 'datetime'

    return schema.type
  }, [schema.format, schema.type])

  const handleValueChange = (value: (typeof types)[number]): void => {
    if (value === 'date' || value === 'datetime') {
      return onChange({ type: 'string', format: value })
    }

    return onChange({
      type: value,
      format: undefined,
      items: value === 'array' ? ({} as PropertySchema) : undefined,
    })
  }

  return (
    <Select value={type} onValueChange={handleValueChange}>
      <SelectTrigger id={id} className="w-[180px]">
        <SelectValue placeholder="Select type" />
      </SelectTrigger>
      <SelectContent>
        {types.map((type) => (
          <SelectItem key={type} value={type}>
            {type}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
